import { Node as ReactFlowNode } from '@xyflow/react';
import { useCallback } from 'react';

import { useFlowChartContext } from '../../context/flowChart.context';
import { InternalFlowChartProps, Node } from '../../types';
import { useIsInteractive } from '../useIsInteractive';
/**
 * @description Wrapper around nodes changed callback to keep track of our "dirty state"
 * dirty == is interactive + nodes have been changed
 * pristine == not interactive
 */
export function useInternalOnNodesChange<T extends ReactFlowNode = Node>({
  onNodesChange: onNodesChangeProp,
}: InternalFlowChartProps<T>): InternalFlowChartProps<T>['onNodesChange'] {
  const { getIsInteractive } = useIsInteractive();
  const {
    __internal: { setIsDirty },
  } = useFlowChartContext();

  const onNodesChange = useCallback<
    NonNullable<InternalFlowChartProps<T>['onNodesChange']>
  >(
    (...args) => {
      setIsDirty(getIsInteractive());
      onNodesChangeProp?.(...args);
    },
    [getIsInteractive, onNodesChangeProp, setIsDirty]
  );

  return onNodesChange;
}
